import { Box, Container } from '@chakra-ui/react';
import dynamic from 'next/dynamic';
import { Article as ArticleProps } from '../../types';
import Fields from '../Fields';
import ArticleHero from '../ArticleHero';
import Author from '../Author';
import ArticleContainer from '../ArticleContainer';
import { splitFields } from './Page';

const SelectedEntries = dynamic(() => import('../SelectedEntries'));
const SocialShare = dynamic(() => import('../SocialShare'), {
  ssr: false,
});

const Article = ({
  post_title: title,
  featured_image,
  related,
  post_date,
  fields,
  author,
}: ArticleProps) => {
  const { basicFields, sectionFields } = splitFields(fields);

  return (
    <ArticleContainer>
      {/* Box here is to avoid grid-gap between hero and content, which comes from ArticleContainer */}
      <Box>
        <ArticleHero title={title} image={featured_image} date={post_date} />
        <Container maxW="container.sm" variant="noSpacing">
          <Fields fields={basicFields} fieldsType="basic" />
          {author && <Author {...author} />}
          <SocialShare title={title} />
        </Container>
      </Box>

      {related?.items?.length || sectionFields?.length ? (
        <>
          {related?.items?.length ? (
            <SelectedEntries
              entries={related.items}
              heading={related.title}
              isOrderedContent
            />
          ) : null}
          {sectionFields && <Fields fields={sectionFields} />}
        </>
      ) : null}
    </ArticleContainer>
  );
};

export default Article;
